import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import cn from 'classnames';
import './BrandOnboardingRegistrationPanel.scss';

import { registerBrand } from '../../../Actions/OnboardingActions';
import { getAndRemoveUrlParam } from '../../../Helpers/helpers';

const BrandOnboardingRegistrationPanel = props => {
  const [code, setCode] = useState('');

  useEffect(() => {
    const codeFromUrlParam = getAndRemoveUrlParam('code');
    if (codeFromUrlParam) setCode(codeFromUrlParam);
  }, []);

  const registerBrand = async () => {
    if (props.isLoading) return;
    if (!code) return window.ALERT.error('Please enter a registration code.');

    props.setIsLoading(true);
    try {
      const registrationResponse = await props.registerBrand(code);
      if (!registrationResponse.success) throw new Error(registrationResponse.error);

      window.ALERT.success(`Welcome to ShopMy ${registrationResponse.brand.name}!`);
      props.goToNextPanel();
    } catch (e) {
      window.ALERT.error('An error occurred while registering. Please try again.');
      console.error(e);
      props.setIsLoading(false);
    }
  };

  return (
    <div className='brand-onboarding-registration-panel-outer'>
      <img
        className='brand-onboarding-registration-panal-background-image'
        src='https://askemma-static-public.s3.us-east-2.amazonaws.com/Onboarding/Brands/ob_home.png'
        alt='registration panel background'
      />

      <div className={cn('brand-onboarding-registration-panel-inner', { isLoading: props.isLoading })}>
        <div className='brand-onboarding-label-text'>Brand Onboarding</div>
        <div className='brand-onboarding-header-text'>Welcome, let's get you setup.</div>
        <div className='brand-onboarding-description-text'>
          We are thrilled to begin this partnership—this portal will customize your account to you and set you up for success with ShopMy!
        </div>

        <input
          className='brand-onboarding-input'
          type='text'
          placeholder='Enter Your Registration Code Here'
          value={code}
          onChange={e => setCode(e.target.value)}
        />
        <button className='brand-onboarding-registration-button registration' onClick={registerBrand} disabled={props.isLoading}>
          Submit Code
        </button>
        <a className='brand-onboarding-registration-panel-redirect' href='https://shopmy.com/home/creators'>
          I am a creator
        </a>
      </div>
    </div>
  );
};

BrandOnboardingRegistrationPanel.propTypes = {
  goToNextPanel: PropTypes.func.isRequired,
  registerBrand: PropTypes.func.isRequired
};

const mapStateToProps = state => {
  const { brandOnboarding } = state;
  return { brandOnboarding };
};

export default connect(mapStateToProps, {
  registerBrand
})(withRouter(BrandOnboardingRegistrationPanel));
